import { start, end } from './metric';

/**
 * Util that wraps the passed function in between a metric
 * @param {String} name Metric Name
 * @param {Function} func
 * @param {Object} context
 * @return {Function}
 */
export default function wrapBench(name, func, context) {
  return (...args) => {
    start(name);
    const result = func.apply(context, args);

    if (!result || !result.then) {
      end(name);
      return result;
    }

    return result.then(value => {
      end(name);
      return value;
    });
  };
}
